import React, { useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import ScrollReveal from "scrollreveal";
import Navbar from "./Navbar";
import MainSlider from "./Home/MainSlider";
// import Product from "./Extra/Product";
import ExploreEthiccraft from "./Home/Explore_Ethiccraft";
// import RecentEvents from "./Extra/RecentEvents";
import Testimonials from "./Home/Testimonials_old";
import Ourreach from "./Home/Ourreach";
import Leaders from "./Home/Leaders";
import UpcomingEvents from "./Home/Upcoming_Events";
import SpiritofCelebration from "./Home/SpiritofCelebration";
import OurCauses from "./Home/Our_Causes";
import Footer from "./Footer";
import './Css/Homepage.css'

function Home() {
  useEffect(() => {
    const scrollRevealOption = {
      distance: "50px",
      origin: "bottom",
      duration: 1000,
    };

    ScrollReveal().reveal(".header__image img", { ...scrollRevealOption, origin: "right" });
    ScrollReveal().reveal(".header__content h1", { ...scrollRevealOption, delay: 500 });
    ScrollReveal().reveal(".header__content p", { ...scrollRevealOption, delay: 1000 });
    ScrollReveal().reveal(".header__image__content", { duration: 1000, delay: 1500 });
    ScrollReveal().reveal(".product__image img", { ...scrollRevealOption, origin: "left" });
    ScrollReveal().reveal(".product__card", { ...scrollRevealOption, delay: 500, interval: 500 });
  }, []);

  return (
    <AnimatePresence>
      <Navbar />
      <MainSlider />
      <UpcomingEvents />
      <Ourreach />
      <ExploreEthiccraft />
      <OurCauses />
      <Leaders />
      <SpiritofCelebration />
      <Testimonials />
      <Footer />
    </AnimatePresence>
  );
}

export default Home;